export default __webpack_public_path__ + "static/media/portalUsers.141b6b14.svg";